import React from 'react';
import { sumBy, meanBy, map } from 'lodash';
import DiffAndChange from '../DiffAndChange';
import { splitByThousands, convertToThousands } from '../../../helpers/NumberFormatter';
import AbsoluteValue from '../AbsoluteValue';

export {
	summaryFooter,
	diffFooter
}

function summaryFooter(totals, key, currency, digits) {
	return <React.Fragment>
		<AbsoluteValue currency={true} value={totals[`curr_${key}_income`]}></AbsoluteValue>
		<br/>
		<AbsoluteValue currency={false} value={totals[`curr_${key}_quantity`]}></AbsoluteValue>
	</React.Fragment>;
}

function diffFooter(totals, key) {
	return <React.Fragment>
		<DiffAndChange className="percent-value" field={`${key}_income`} item={totals} currency={true}/>
		<br />
		<DiffAndChange className="percent-value" field={`${key}_quantity`} item={totals} currency={false}/>
	</React.Fragment>
}
